import handleListingAnalytics from './listingHandlers';

export const analyticsMetadataFromAction = action =>
  action?.meta?.analytics || action?.analytics || action?.payload?.analytics;

export const handleDeclarativeAnalytics = (
  action,
  { track, defaultProps = {} } = {}
) => {
  const metadata = analyticsMetadataFromAction(action);
  if (!metadata?.event) return undefined;

  return track(
    metadata.event,
    {
      ...defaultProps,
      ...(metadata.properties || {}),
    },
    { variant: metadata.variant }
  );
};

export const defaultAnalyticsHandlers = Object.freeze([
  handleListingAnalytics,
  handleDeclarativeAnalytics,
]);

export const dispatchAnalytics = (
  action,
  { handlers = defaultAnalyticsHandlers, ...context } = {}
) => {
  let dispatched;
  handlers.some(handler => {
    const result = handler(action, context);
    if (result === undefined) return false;

    dispatched = result;
    return true;
  });

  return dispatched === undefined ? null : dispatched;
};

export { LAIS_ANALYTICS_ACTIONS } from './listingHandlers';
